export default __webpack_public_path__ + "static/media/youtubeMp3-Mp4.bbaabb3a.gif";